<script setup lang="ts">
import AdminLayout from './components/layout/AdminLayout.vue'
</script>

<template>
  <AdminLayout />
</template>

<style>
#app {
  height: 100vh;
  font-family: var(--aw-font-sans);
  color: var(--aw-text-primary);
  background-color: var(--aw-bg-base);
}
</style>
